import { Controller, ActionEvent } from "@hotwired/stimulus";

export default class TabsController extends Controller {
  static targets = ["tab", "dateRange"];

  static values = {
    session: String,
  };

  declare tabTargets : HTMLLinkElement[];
  declare dateRangeTarget: HTMLDivElement;
  declare sessionValue: string;

  connect(): void {
    const tabStatusValue = this.sessionValue

    this.hideDateFilter(tabStatusValue)
    this.selectTab(tabStatusValue)
  }

  private selectTab(status: string) :void {
    if (status != 'live') {
      for (const el of this.tabTargets)
        el.classList.remove("is-active");

      this.tabTargets.map(tab => {
        if (tab.querySelector('span')?.innerHTML.toLowerCase() == status) {
          tab.classList.add('is-active')
        }
      })
    }
  }

  // hiding the date filter for promotions that do not require it.
  private hideDateFilter(tabStatusValue: string): void {
    if (tabStatusValue !== "completed") {
      this.dateRangeTarget?.classList.add("is-hidden")
    } else {
      this.dateRangeTarget?.classList.remove("is-hidden")
    }
  }

  switch(ev: ActionEvent) : void {
    const { status } = ev.params as { status: string }

    this.hideDateFilter(status)

    if (ev.currentTarget instanceof HTMLElement) {
      const tabIndex = ev.currentTarget.getAttribute("data-tab-index");

      for (const el of this.tabTargets)
        el.classList.remove("is-active");

      const finder = (el : HTMLElement) => el.getAttribute("data-tab-index") == tabIndex;

      const tabEl = this.tabTargets.find(finder);

      tabEl?.classList.add("is-active");
    }
  }
}
